import { Controller } from "@hotwired/stimulus"

// Mobile calendars: a day strip (week) or mini calendar (month) above a list.
// Only the selected day's list is shown; the month view can switch to the
// whole month, in which case tapping a day scrolls to it instead.
export default class extends Controller {
  static targets = ["dayCell", "dayPanel", "toggleAll"]
  static values = { mode: String, selectedDate: String, today: String, showAll: Boolean, showAllText: String, showSelectedText: String }

  connect() {
    // "Today" comes from the server in the branch's time zone; the browser's
    // UTC date is a day off around midnight in Poland.
    const today = this.todayValue || new Date().toISOString().split("T")[0]
    const firstDate = this.dayCellTargets[0]?.dataset.date
    const dateToSelect = this.dayCellTargets.find(c => c.dataset.date === today) ? today : firstDate

    if (dateToSelect) {
      // Defer so the full page layout is settled before scrolling
      requestAnimationFrame(() => this.selectDay(dateToSelect))
    }
  }

  select(event) {
    event.preventDefault()
    const date = event.currentTarget.dataset.date
    if (date) this.selectDay(date)
  }

  toggleAll() {
    this.showAllValue = !this.showAllValue
    if (this.hasToggleAllTarget) {
      this.toggleAllTarget.textContent = this.showAllValue ? this.showSelectedTextValue : this.showAllTextValue
    }
    this.selectDay(this.selectedDateValue || this.dayCellTargets[0]?.dataset.date)
  }

  selectDay(date) {
    if (!date) return
    this.selectedDateValue = date

    this.dayCellTargets.forEach(cell => {
      const isSelected = cell.dataset.date === date
      cell.classList.toggle("ring-2", isSelected)
      cell.classList.toggle("ring-primary", isSelected)
      cell.classList.toggle("bg-primary", isSelected)
      cell.classList.toggle("text-primary-content", isSelected)
    })

    if (this.modeValue === "agenda" && this.showAllValue) {
      this.dayPanelTargets.forEach(panel => panel.classList.remove("hidden"))
      const target = document.getElementById(`agenda-day-${date}`)
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" })
    } else {
      this.dayPanelTargets.forEach(panel => {
        panel.classList.toggle("hidden", panel.dataset.date !== date)
      })
    }
  }
}
